import { render } from "./EditProvider.vue?vue&type=template&id=00f6dbd4"
import script from "./EditProvider.vue?vue&type=script&lang=js"
export * from "./EditProvider.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__